const breakpoint = {
  tablet: '@media(min-width:768px)',
  desktopXLarge: '@media(min-width:1920px)'
}

export default breakpoint
